import React from "react";
import MembershipTypeFilter from "./MembershipTypeFilter";
import DurationFilter from "./DurationFilter";
import CustomDateRanges from "./CustomDateRanges";
import DatePicker from "./DatePicker";
import UpdateButtons from "./UpdateButtons";

const FilterBar = ({ isFreezeHistory = false }) => (
  <div id="override-edit-selection-bar" className="edit-selections-bar">
    <div className="top-filter">
      <div className="top-filter__left">
        <MembershipTypeFilter />
        <DurationFilter />
      </div>

      <div className="top-filter__right">
        {isFreezeHistory && (
          <div className="select-box-no-width date-range-select-box">
            <p>Date Range</p>
            <CustomDateRanges />
          </div>
        )}

        <DatePicker isRangePicker={isFreezeHistory} />
      </div>
    </div>

    <UpdateButtons />
  </div>
);

export default FilterBar;
